export enum OcbHttpVerbs {
    DELETE = 1,
    POST = 2,
    GET = 3,
}
